import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    '&&': {
      display: 'flex',

      [theme.breakpoints.down('tablet')]: {
        alignItems: 'center',
        flexDirection: 'column',
      },

      [theme.breakpoints.up('tablet')]: {
        gap: SPACES.xxxxxxl,
        flexWrap: 'wrap',
      },
    },
  },
  formWrapper: {
    '&&': {
      position: 'relative',
      flexDirection: 'column',

      [theme.breakpoints.down('tablet')]: {
        alignItems: 'center',
        gap: SPACES.xxl,
        marginBottom: SPACES.xxl,
      },

      [theme.breakpoints.up('tablet')]: {
        gap: '2.5rem',

        maxWidth: 800,
      },
      [theme.breakpoints.up('laptop')]: {
        padding: SPACES.xs,
        maxWidth: 840,
      },
    },
  },
  mainImageWrapper: {
    '&&': {
      marginRight: 'auto',
    },
  },
  inputWrapper: {
    '&&': {
      width: '100%',
      gap: SPACES.xs,

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'end',
    },
  },
  formButton: {
    '&&': {
      borderRadius: '1.6rem',

      fontSize: FONTS.SIZES.s,
      textTransform: 'none',
      fontWeight: FONTS.WEIGHTS.bold,

      [theme.breakpoints.down('tablet')]: {
        width: 150,
        height: 40,
      },
      [theme.breakpoints.up('tablet')]: {
        marginTop: 10,

        width: 146,
        height: 50,
      },
    },
  },
  formButtonGrey: {
    '&&': {
      borderRadius: 10,
      backgroundColor: theme.palette.custom.grey,
      justifyContent: 'flex-start',

      color: theme.palette.custom.darkBlue2,

      '&:hover, &:focus': {
        color: theme.palette.custom.white,

        '& > svg > path': {
          fill: theme.palette.custom.white,
        },
      },
    },
  },
  formButtonLight: {
    '&&': {
      backgroundColor: theme.palette.custom.white,
      color: theme.palette.custom.darkBlue2,
    },
  },
}))

export default useStyles
